import type { App } from 'vue';
import type { ArcoIconOptions } from '../../_utils/types';
import _IconDefaultAvatarDarkColor from './icon-default-avatar-dark-color.vue';

const IconDefaultAvatarDarkColor = Object.assign(_IconDefaultAvatarDarkColor, {
  install: (app: App, options?: ArcoIconOptions) => {
    const iconPrefix = options?.iconPrefix ?? '';
    app.component(iconPrefix + _IconDefaultAvatarDarkColor.name, _IconDefaultAvatarDarkColor);
  }
});

export default IconDefaultAvatarDarkColor;
